import React from "react";
import useRouteUtils from "../../utils/hooks/useRouteUtils";

const useCampaign = () => {
  const { checkIfActiveRoute } = useRouteUtils();

  const drawerMenu = [
    {
      title: "Ad Analytics",
      link: "/dashboard",
      icon: <span className="material-symbols-outlined x4"> group </span>,
      active: checkIfActiveRoute("/dashboard", true),
    },
    {
      title: "Client",
      link: "/dashboard/clients",
      icon: <span className="material-symbols-outlined x4"> group </span>,
      active: checkIfActiveRoute("/dashboard/clients", true),
    },
    {
      title: "Campaign",
      link: "/dashboard/campaign",
      icon: <span className="material-symbols-outlined x4"> group </span>,
      active: checkIfActiveRoute("/dashboard/campaign", true),
    },
    {
      title: "Ads",
      link: "/dashboard/advertisement",
      icon: <span className="material-symbols-outlined x4"> group </span>,
      active: checkIfActiveRoute("/dashboard/advertisement", true),
    },
  ];

  return {
    drawerMenu,
  };
};

export default useCampaign;